import script from "./repeat-order-user-phone-form.vue?vue&type=script&setup=true&lang=ts"
export * from "./repeat-order-user-phone-form.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__